import { CardContent } from '@lms/ui/card';
import { cn } from '@lms/ui/utils';
import type { ComponentProps } from 'react';

/**
 * CardContent for a table that runs edge-to-edge: row borders and hover reach
 * the card's sides and bottom, while the outer cells keep the card's inset so
 * text lines up with the CardHeader. Give the Card `overflow-hidden` so the
 * last row's hover follows the rounded corners.
 */
export function CardTableContent({
  className,
  ...props
}: ComponentProps<typeof CardContent>) {
  return (
    <CardContent
      className={cn(
        'p-0 [&_td:first-child]:pl-6 [&_td:last-child]:pr-6 [&_th:first-child]:pl-6 [&_th:last-child]:pr-6',
        className,
      )}
      {...props}
    />
  );
}
